import React from "react";
import { Card, CardContent, CardHeader } from "../../ui/card";
import {
  Table,
  TableHeader,
  TableBody,
  TableRow,
  TableCell,
  TableHead,
} from "../../ui/table";

interface Comparison {
  id: number;
  comparisonName: string;
  rateOfReturn: number;
  expectedIncomePercentage: number;
  yearsUntilIncome: number;
}

interface ComparisonsTableProps {
  data: {
    year: number;
    tspBalance: number;
    tspIncome: number;
    [key: string]: number | undefined;
  }[];
  comparisons: Comparison[];
}

const ComparisonsTable: React.FC<ComparisonsTableProps> = ({
  data,
  comparisons,
}) => {
  const formatCurrency = (value: number | undefined) => {
    if (value === undefined || value === null) return "N/A";
    return `$${value.toFixed(2).replace(/\d(?=(\d{3})+\.)/g, "$&,")}`;
  };

  return (
    <Card className="mb-8">
      <CardHeader>
        <h4 className="text-lg font-semibold text-gray-700">
          Quick Results Federal
        </h4>
      </CardHeader>
      <CardContent>
        <div className="overflow-x-auto">
          <Table>
            <TableHeader>
              <TableRow className="bg-gray-100">
                <TableHead>Year</TableHead>
                <TableHead>TSP Balance</TableHead>
                <TableHead>TSP Income</TableHead>
                {comparisons.map((comparison, index) => (
                  <React.Fragment key={comparison.id}>
                    <TableHead>{`${comparison.comparisonName} Balance`}</TableHead>
                    <TableHead>{`${comparison.comparisonName} Diff`}</TableHead>
                    <TableHead>{`${comparison.comparisonName} Income`}</TableHead>
                    <TableHead>{`${comparison.comparisonName} Diff Income`}</TableHead>
                  </React.Fragment>
                ))}
              </TableRow>
            </TableHeader>
            <TableBody>
              {data.map((row, index) => (
                <TableRow key={index}>
                  <TableCell>{row.year}</TableCell>
                  <TableCell>{formatCurrency(row.tspBalance)}</TableCell>
                  <TableCell>{formatCurrency(row.tspIncome)}</TableCell>
                  {comparisons.map((comparison, compIndex) => (
                    <React.Fragment key={comparison.id}>
                      <TableCell>
                        {formatCurrency(row[`balance${compIndex}`])}
                      </TableCell>
                      <TableCell>
                        {formatCurrency(row[`diff${compIndex}`])}
                      </TableCell>
                      <TableCell>
                        {formatCurrency(row[`income${compIndex}`])}
                      </TableCell>
                      <TableCell>
                        {formatCurrency(row[`diffIncome${compIndex}`])}
                      </TableCell>
                    </React.Fragment>
                  ))}
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </div>
      </CardContent>
    </Card>
  );
};

export default ComparisonsTable;
